<template>
    <form class="set-field-value">
        <div id="field_value_summary_info">
            {{ HEADER.TITLE }}
        </div>
        <div id="field_value_summary_description">
            {{ HEADER.DESCRIPTION }}
        </div>
        <ds-multiselect
            v-model="option"
            label-prop="label"
            value-prop="value"
            :placeholder="LABELS_VALUES.OPTION"
            :options="OPTIONS_VALUES"
            required
            class="field-value-options"
            @input="switchOption"
        >
            <template #option="{ option : opt, highlight, dense, isSelected }">
                <div
                    :class="['menu-item', {
                        dense,
                        selected: isSelected,
                    }]"
                >
                    <div>
                        <span>{{ opt.label }}</span>
                        <br />
                        <span
                            v-if="opt && opt.description"
                            class="option-description-span"
                        >
                            {{ opt.description }}
                        </span>
                    </div>
                </div>
            </template>
        </ds-multiselect>
        <div
            id="field-config-container"
            :class="fieldClass"
        >
            <div
                id="select-field-div"
                :class="fieldClass"
            >
                <ds-multiselect
                    v-if="option.value"
                    v-model="config.fieldName"
                    :label="LABELS_VALUES.FIELD"
                    :placeholder="LABELS_VALUES.FIELD"
                    bind-value-only
                    searchable
                    :options="getFields()"
                    required
                    @input="bindFieldValueSelect(false)"
                />
            </div>
            <div
                v-if="isLoadFieldConfigRenderDiv && !config.useTodaysDate"
                id="field-config-render"
            >
                <!-- Content Ajaxed in after selecting a value -->
            </div>
            <ds-select-field
                v-if="option.value === this.$options.constants.OPTION_VALUES.MATH"
                v-model="config.mathOption"
                class="math-option-values"
                :label="LABELS_VALUES.MATH"
                :placeholder="LABELS_VALUES.MATH"
                bind-value-only
                :options="MATHOPTIONS_VALUES"
                required
                @input="enableSave"
            />
            <ds-input-field
                v-if="option.value === this.$options.constants.OPTION_VALUES.MATH"
                v-model="config.fieldValue"
                class="math-values"
                :label="LABELS_VALUES.QUANTITY"
                type="number"
                required
                :maxlength="this.$options.constants.LIMITS.QUANTITY_MAXLENGTH"
                :min="this.$options.constants.LIMITS.MIN_QUANTITY"
                :max="this.$options.constants.LIMITS.MAX_QUANTITY"
                @input="enableSave"
            />
        </div>
        <ds-checkbox
            v-if="isLoadFieldConfigRenderDiv && (config.fieldDataType === 'date' || config.fieldDataType === 'datetime')"
            v-model="config.useTodaysDate"
            class="date-checkbox"
            :label="LABELS_VALUES.DATE"
            @input="handleDateCheckbox"
        />
        <ds-card class="additional-info">
            <ds-icon name="info-circle" />
            <ds-card-body>
                {{ PROTIP_VALUES.TEXT }}
                <a target="_blank" :href="PROTIP_VALUES.LINK_URL">{{ PROTIP_VALUES.LINK_TEXT }}</a>
            </ds-card-body>
        </ds-card>
        <ds-filled-button
            class="savebutton"
            :disabled="isReadyToSave"
            @click="saveCell"
        >
            {{ ACTIONS_VALUE.SAVE }}
        </ds-filled-button>
        <ds-icon-button
            class="closemodal"
            @click="closeModal"
        >
            <ds-icon name="x" />
        </ds-icon-button>
    </form>
</template>

<script>
import {
    OPTION_VALUES,
    LIMITS,
} from './constants';
import { dataService } from '../shared/data.service';

export default {
    props: {
        vueComponentId: String,
    },
    data() {
        return {
            graph: {},
            cell: {},
            cellValue: {},
            saveCellOptions: {},
            LABELS_VALUES: {
                OPTION: '',
                FIELD: '',
                DATE: '',
                MATH: '',
                QUANTITY: '',
            },
            OPTIONS_VALUES: [
                {
                    label: '',
                    description: '',
                    value: 'overwrite',
                },
                {
                    label: '',
                    description: '',
                    value: 'set',
                },
                {
                    label: '',
                    description: '',
                    value: 'clear',
                },
                {
                    label: '',
                    description: '',
                    value: 'math',
                },
            ],
            PROTIP_VALUES: {
                TEXT: '',
                LINK_TEXT: '',
                LINK_URL: 'https://help.keap.com/help/set-the-value-of-a-field-in-a-sequence',
            },
            MATHOPTIONS_VALUES: [
                {
                    label: '',
                    value: 'add',
                },
                {
                    label: '',
                    value: 'subtract',
                },
                {
                    label: '',
                    value: 'multiply',
                },
                {
                    label: '',
                    value: 'divide',
                },
            ],
            ACTIONS_VALUE: {
                SAVE: '',
            },
            HEADER: {
                TITLE: '',
                DESCRIPTION: '',
            },
            config: {
                fieldName: '',
                fieldValue: '',
                fieldDataType: '',
                overwriteExistingValue: false,
                useTodaysDate: false,
                clearExistingValue: false,
                mathOption: '',
            },
            fields: [],
            option: {},
            fieldClass: 'field-class',
            fieldConfigRender: '',
            saveEnabled: false,
        };
    },
    async created() {
        await this.loadFields();
        this.OPTIONS_VALUES[0].label = window.keapI18nMap['campaign.set.field.value.overwrite'];
        this.OPTIONS_VALUES[1].label = window.keapI18nMap['campaign.set.field.value.set'];
        this.OPTIONS_VALUES[2].label = window.keapI18nMap['campaign.set.field.value.clear'];
        this.OPTIONS_VALUES[3].label = window.keapI18nMap['campaign.set.field.value.use.math'];
        this.OPTIONS_VALUES[0].description = window.keapI18nMap['campaign.set.field.value.overwrite.description'];
        this.OPTIONS_VALUES[1].description = window.keapI18nMap['campaign.set.field.value.set.description'];
        this.OPTIONS_VALUES[2].description = window.keapI18nMap['campaign.set.field.value.clear.description'];
        this.OPTIONS_VALUES[3].description = window.keapI18nMap['campaign.set.field.value.use.math.description'];
        this.LABELS_VALUES.DATE = window.keapI18nMap['campaign.set.field.value.date'];
        this.LABELS_VALUES.OPTION = window.keapI18nMap['campaign.set.field.value.option'];
        this.LABELS_VALUES.MATH = window.keapI18nMap['campaign.set.field.value.math'];
        this.LABELS_VALUES.FIELD = window.keapI18nMap['campaign.set.field.value.field'];
        this.LABELS_VALUES.QUANTITY = window.keapI18nMap['campaign.set.field.value.quantity'];
        this.PROTIP_VALUES.LINK_TEXT = window.keapI18nMap['campaign.set.field.pro.tip.link.text'];
        this.MATHOPTIONS_VALUES[0].label = window.keapI18nMap['campaign.set.field.value.add'];
        this.MATHOPTIONS_VALUES[1].label = window.keapI18nMap['campaign.set.field.value.subtract'];
        this.MATHOPTIONS_VALUES[2].label = window.keapI18nMap['campaign.set.field.value.multiply'];
        this.MATHOPTIONS_VALUES[3].label = window.keapI18nMap['campaign.set.field.value.divide'];
        this.ACTIONS_VALUE.SAVE = window.keapI18nMap['campaign.landing.page.save'];
        this.PROTIP_VALUES.TEXT = window.keapI18nMap['campaign.set.field.value.pro.tip.text'];
        this.HEADER.TITLE = window.keapI18nMap['campaign.set.field.value.header.title'];
        this.HEADER.DESCRIPTION = window.keapI18nMap['campaign.set.field.value.header.title.description'];
    },
    mounted () {
        document.getElementById(this.vueComponentId).addEventListener('loadCellValueObject', this.loadCellValueObject);
    },
    beforeDestroy () {
        document.getElementById(this.vueComponentId).removeEventListener('loadCellValueObject');
    },
    computed: {
        isLoadFieldConfigRenderDiv: {
            cache: false,
            get() {
                return this.config.fieldName !== ''
                        && (this.option.value === OPTION_VALUES.OVERWRITE || this.option.value === OPTION_VALUES.SET);
            },
        },

        isReadyToSave: {
            cache: false,
            get() {
                const readyToSave = (this.option && this.config.fieldName !== '' && this.config.fieldValue !== '' && this.saveEnabled === true)
                        || (this.option.value === OPTION_VALUES.CLEAR && this.config.fieldName !== '' && this.saveEnabled === true)
                        || (((this.config.fieldDataType === 'datetime' || this.config.fieldDataType === 'date') && this.saveEnabled === true) && (this.config.fieldValue !== '' || this.config.useTodaysDate === true));

                return !readyToSave;
            },
        },
    },
    methods: {
        async loadFields() {
            this.fields = await dataService.getContactFields();
        },

        loadCellValueObject (event) {
            this.$nextTick(function() {
                this.init(event);
            });
        },

        async init(event) {
            this.saveEnabled = false;
            this.graph = event.detail.jgraph;
            this.cell = event.detail.cellInfo;
            this.cellValue = event.detail.cellValue;
            this.saveCellOptions = event.detail.options;
            this.saveCellOptions.saver = undefined;

            if (Infusion.NumberUtils.isValidLongId(this.cellValue.fieldValueFileBoxId)) {
                this.enableSave();
                this.config = await dataService.getFieldValueConfig(this.cellValue.fieldValueFileBoxId);

                if (this.config.fieldDataType === 'dateTime') {
                    this.config.fieldDataType = 'datetime';
                }
                this.setOption();
            }
        },

        setOption() {
            if (this.isOverwriteValueOption()) {
                this.option = this.searchOption(OPTION_VALUES.OVERWRITE, this.OPTIONS_VALUES);
            } else if (this.isClearValueOption()) {
                this.option = this.searchOption(OPTION_VALUES.CLEAR, this.OPTIONS_VALUES);
            } else if (this.isUseMathOption()) {
                this.option = this.searchOption(OPTION_VALUES.MATH, this.OPTIONS_VALUES);
            } else {
                this.option = this.searchOption(OPTION_VALUES.SET, this.OPTIONS_VALUES);
            }
            this.restorePreviousSelections();
        },

        isOverwriteValueOption() {
            return this.config.overwriteExistingValue && !this.config.clearExistingValue && this.config.mathOption === '';
        },

        isClearValueOption() {
            return this.config.overwriteExistingValue && this.config.clearExistingValue;
        },

        isUseMathOption() {
            return this.config.overwriteExistingValue && this.config.mathOption !== '';
        },

        searchOption(value, array) {
            let selectedValue = {};

            for (let i = 0; i < array.length; i++) {
                if (array[i].value === value) {
                    selectedValue = array[i];
                }
            }

            return selectedValue;
        },

        restorePreviousSelections() {
            this.bindFieldValueSelect(true);
        },

        bindFieldValueSelect(loadPreviousSelection) {
            const { fieldName } = this.config;
            const { afterFill } = this;
            let fieldValue = null;

            if (loadPreviousSelection) {
                fieldValue = this.config.fieldValue ? this.config.fieldValue : null;
            } else {
                this.config.fieldValue = '';
                this.enableSave();
                this.config.useTodaysDate = false;
            }

            if (this.isLoadFieldConfigRenderDiv && this.config.useTodaysDate === false) {
                const xhr = new XMLHttpRequest();
                const url = '/app/fieldValueFunnel/renderVueFieldValueConfig';

                xhr.open('POST', url);
                xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

                xhr.onload = function () {
                    if (xhr.readyState === XMLHttpRequest.DONE) {
                        if (xhr.status === 200) {
                            document.getElementById('field-config-render').innerHTML = xhr.response;
                            Infusion.Funnel.Dirty.markDirty();
                            afterFill();
                        }
                    }
                };
                xhr.send(JSON.stringify({
                    fieldName,
                    fieldValue,
                }));
            } else if (this.option.value === OPTION_VALUES.CLEAR) {
                if (!loadPreviousSelection) {
                    this.enableSave();
                    Infusion.Funnel.Dirty.markDirty();
                }
            } else if (this.option.value === OPTION_VALUES.MATH) {
                this.fieldClass = 'field-class-math-short';
            }
        },

        enableSave() {
            this.saveEnabled = true;
        },

        afterFill() {
            const fieldValueDetails = this.getSelectedFieldDetails(this.config.fieldName, false);
            const fieldAndLabelElements = this.getFieldAndLabelSelectors(this.config.fieldName);

            this.attachEventListeners(fieldAndLabelElements);

            this.config.fieldDataType = fieldValueDetails.fieldType;

            if (fieldValueDetails.fieldType === 'email') {
                const permissionCheckQuery = `[id^="permissionCheck_${this.config.fieldName}"]`;

                document.querySelector(permissionCheckQuery).style.display = 'none';
            }
            this.handleFieldValueStyling();
        },

        getSelectedFieldDetails(fieldName, isUpdatingValue) {
            const fieldValueDetails = {};
            let fieldAndLabelElements = {};
            let fieldSelector = '';

            fieldAndLabelElements = this.getFieldAndLabelSelectors(fieldName);
            const fieldValueElementType = fieldAndLabelElements.fieldSelector.attr('type') || fieldAndLabelElements.fieldSelector.prop('type');

            fieldValueDetails.fieldName = fieldName;
            fieldValueDetails.fieldLabel = fieldAndLabelElements.fieldSelector.text().trim();

            switch (fieldValueElementType) {
            case 'radio':
                // Returns selected radio option's 'value'
                fieldSelector = this.getFieldSelector(fieldName);

                fieldValueDetails.fieldValue = jQuery(`${fieldSelector}:checked`).val();
                fieldValueDetails.fieldType = 'radio';
                break;
            case 'select-one':
                // Returns key of selected value
                fieldValueDetails.fieldValue = fieldAndLabelElements.fieldSelector.val();
                fieldValueDetails.fieldType = 'select-one';
                break;
            case 'select-multiple':
                // Returns an array value
                fieldValueDetails.fieldValue = fieldAndLabelElements.fieldSelector.val();
                fieldValueDetails.fieldType = 'select-multiple';
                break;
            case 'email':
                fieldValueDetails.fieldValue = fieldAndLabelElements.fieldSelector.val();
                fieldValueDetails.fieldType = 'email';
                break;
            case 'textarea':
                fieldValueDetails.fieldValue = fieldAndLabelElements.fieldSelector.val();
                fieldValueDetails.fieldType = 'textarea';
                break;
            case 'text':
                fieldValueDetails.fieldValue = fieldAndLabelElements.fieldSelector.val();

                if (this.isDateField()) {
                    fieldValueDetails.fieldType = 'date';
                } else {
                    fieldValueDetails.fieldType = 'text';
                }
                break;
            case 'hidden':
                fieldValueDetails.fieldValue = fieldAndLabelElements.fieldSelector.val();
                fieldValueDetails.fieldType = 'hidden';

                if (fieldAndLabelElements.fieldSelector.hasClass('inf-datetime-value')) {
                    fieldValueDetails.fieldType = 'datetime';

                    if (isUpdatingValue === true) {
                        this.handleDateTimeChange();
                        fieldValueDetails.fieldValue = this.config.fieldValue;
                    }
                }
                break;
            default:
            }

            return fieldValueDetails;
        },

        getFieldAndLabelSelectors(fieldName) {
            const fieldAndLabel = {};
            const fieldAndLabelElements = {};

            // Company info is a special field because it has a hidden field that ultimately has the Id of the company to link and that is the value we really care about.
            if (fieldName === 'companyInfo') {
                fieldAndLabel.labelSelector = `label[for|="${fieldName}"]`;
                fieldAndLabel.fieldSelector = `[name|="${fieldName}.linkId"]`;
            } else {
                // Escape the brackets for jQuery selector
                let escapedIdValue = fieldName.replace('[', '\\[');

                escapedIdValue = escapedIdValue.replace(']', '\\]');
                fieldAndLabel.labelSelector = `label[for|="${escapedIdValue}"]`;
                fieldAndLabel.fieldSelector = `[name|="${escapedIdValue}"]`;
            }
            const $fieldValueElement = jQuery(fieldAndLabel.fieldSelector);
            const $fieldLabelElement = jQuery(fieldAndLabel.labelSelector);

            fieldAndLabelElements.labelSelector = $fieldLabelElement;
            fieldAndLabelElements.fieldSelector = $fieldValueElement;

            return fieldAndLabelElements;
        },

        attachEventListeners(fieldAndLabelElements) {
            // event listener for all contact and custom fields except the ones handled below
            fieldAndLabelElements.fieldSelector.on('input', () => {
                this.enableSave();

                if (this.config.fieldDataType === 'radio') {
                    const fieldSelector = this.getFieldSelector(this.config.fieldName);

                    this.config.fieldValue = jQuery(`${fieldSelector}:checked`).val();
                }
                this.config.fieldValue = fieldAndLabelElements.fieldSelector.val();
            });

            // event listener for company field
            if (this.config.fieldName === 'companyInfo') {
                fieldAndLabelElements.fieldSelector.on('change', () => {
                    this.enableSave();
                    this.config.fieldValue = fieldAndLabelElements.fieldSelector.val();
                });
            }

            // event listener for the fields with javascript on them
            jQuery('.inf-field-wrapper').ready(() => {
                const scriptText = jQuery('.inf-field-wrapper').find('script');

                scriptText.remove();
                jQuery('.inf-field-wrapper').append(scriptText);
            });

            // event listeners for date/time field
            jQuery('.inf-date-picker').on('change', this.handleDateTimeChange);
            jQuery('.inf-time-picker').on('change', this.handleDateTimeChange);
        },

        handleFieldValueStyling() {
            this.fieldClass = 'field-class-short';

            if (this.config.fieldName === 'contactNotes') {
                this.fieldClass = 'field-class';
            }
            const fieldValueWrapper = document.getElementById('field-config-render');

            fieldValueWrapper.className = '';
            fieldValueWrapper.classList.add(this.fieldClass);

            if (this.config.fieldName.includes('customFields')) {
                fieldValueWrapper.classList.add(`custom_${this.config.fieldDataType}`);

                if (this.config.fieldDataType === 'textarea') {
                    this.fieldClass = 'field-class';
                }

                if (this.config.fieldDataType === 'text') {
                    const textFields = document.getElementsByClassName('inf-field');

                    for (let i = 0; i < textFields.length; i++) {
                        const val = textFields[i].innerHTML;

                        if (val.includes('&nbsp;')) {
                            fieldValueWrapper.classList.add('custom-text-nbsp');
                        }
                    }
                }

                const websiteField = document.getElementsByClassName('website-img');

                if (websiteField.length > 0) {
                    fieldValueWrapper.classList.add('custom_website');
                }
            } else {
                fieldValueWrapper.classList.add(this.config.fieldName);
            }
        },

        getFieldSelector(fieldName) {
            let fieldSelector = '';
            let escapedIdValue = fieldName.replace('[', '\\[');

            escapedIdValue = escapedIdValue.replace(']', '\\]');
            fieldSelector = `[name|="${escapedIdValue}"]`;

            return fieldSelector;
        },

        isDateField() {
            return jQuery('#field-config-render .inf-date-picker').length > 0;
        },

        handleDateTimeChange() {
            const datePicker = document.getElementsByClassName('inf-date-picker');
            let dateTimeValue = '';

            for (let i = 0; i < datePicker.length; i++) {
                dateTimeValue = datePicker[i].value;
            }

            const timePicker = document.getElementsByClassName('inf-time-picker');

            for (let i = 0; i < timePicker.length; i++) {
                dateTimeValue = `${dateTimeValue} ${timePicker[i].value}`;
            }

            this.config.fieldValue = dateTimeValue;
            this.enableSave();
        },

        switchOption() {
            this.clearConfigValues();

            switch (this.option.value) {
            case OPTION_VALUES.OVERWRITE:
                this.config.overwriteExistingValue = true;
                break;
            case OPTION_VALUES.CLEAR:
                this.config.overwriteExistingValue = true;
                this.config.clearExistingValue = true;
                break;
            case OPTION_VALUES.MATH:
                this.config.overwriteExistingValue = true;
                this.fieldClass = 'field-class-math-short';
                break;
            default:
            }

            Infusion.Funnel.Dirty.markDirty();
        },

        clearConfigValues() {
            this.fieldClass = 'field-class';
            this.fieldConfigRender = '';
            this.config = {
                fieldName: '',
                fieldValue: '',
                fieldDataType: '',
                overwriteExistingValue: false,
                useTodaysDate: false,
                clearExistingValue: false,
                mathOption: '',
            };
        },

        getFields() {
            return this.option.value !== OPTION_VALUES.MATH
                ? (this.option.value !== OPTION_VALUES.OVERWRITE
                    ? this.fields
                    : this.fields.filter((f) => { return f.label !== 'Leadsource'; }))
                : this.fields.filter((f) => { return f.isNumeric === 'true'; });
        },

        handleDateCheckbox(value) {
            this.enableSave();

            if (value === true) {
                this.config.useTodaysDate = true;
                this.fieldClass = 'field-class';
            } else {
                this.config.useTodaysDate = false;
                this.bindFieldValueSelect(false);
            }
        },

        saveCell() {
            const eventData = {
                graph: this.graph,
                cell: this.cell,
                cellValue: this.cellValue,
                saveCellOptions: this.saveCellOptions,
                config: this.config,
            };

            this.bindNewFieldValueToSave();

            const cellValueFileBoxId = this.cellValue.fieldValueFileBoxId;
            const vm = this;

            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();

                xhr.open('PUT', `/app/fieldValueFunnel/${cellValueFileBoxId}`);
                xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                xhr.responseType = 'text';

                xhr.onreadystatechange = function () {
                    if (xhr.readyState === XMLHttpRequest.DONE) {
                        if (xhr.status === 200) {
                            if (!cellValueFileBoxId && xhr.responseText) {
                                vm.cellValue.fieldValueFileBoxId = xhr.responseText;
                            }

                            Infusion.Funnel.Dirty.reset();
                            Infusion.Funnel.Flags.markDirty(eventData.graph, eventData.cell);
                            Infusion.Funnel.Flags.markReady(eventData.graph, eventData.cell);
                            Infusion.Funnel.markDirty();
                            resolve();
                        } else {
                            reject();
                        }
                        vm.closeModal();
                    }
                };

                xhr.send(JSON.stringify({
                    fieldName: eventData.config.fieldName,
                    fieldValue: eventData.config.fieldValue,
                    overwriteExisting: eventData.config.overwriteExistingValue,
                    clearExisting: eventData.config.clearExistingValue,
                    useTodaysDate: eventData.config.useTodaysDate,
                    mathOption: eventData.config.mathOption,
                }));
            });
        },

        bindNewFieldValueToSave() {
            if (this.option.value !== OPTION_VALUES.MATH) { // MATH already has fieldValue bound correctly
                const selectedFieldValueDetails = this.getSelectedFieldDetails(this.config.fieldName, true);

                if (selectedFieldValueDetails.fieldType === 'select-multiple') {
                    if (selectedFieldValueDetails.fieldValue != null) {
                        selectedFieldValueDetails.fieldValue = selectedFieldValueDetails.fieldValue.join(',');
                    }
                }
                this.config.fieldValue = selectedFieldValueDetails.fieldValue;
            }
        },

        closeModal () {
            document.querySelector('span.container-close').click();
        },
    },
    constants: {
        OPTION_VALUES,
        LIMITS,
    },
};
</script>

<style scoped>
    .field-class-short > .select-field {
        width: 90%;
    }

    .field-class-math-short > .select-field {
        width: 90%;
    }

    form > .closemodal {
        grid-area: containerclose;
        background-color: #fff;
        padding: 0;
        margin: 0;
        width: auto;
        height: auto;
        position: absolute;
        top: 17px;
        left: 12px;
    }
</style>
<style lang="scss">
    .set-field-value {
        .field-value-options {
            margin-top: 17px;
        }

        .option-description-span {
            height: 16px;
            align-self: stretch;
            flex-grow: 0;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.33;
            letter-spacing: normal;
            text-align: left;
            color: rgba(0, 0, 0, 0.6);
        }

        .multiselect-single > label {
            margin-top: -6px;
        }

        .multiselect-single > input:focus + label {
            margin-top: 0px;
        }

        .multiselect-single > label.static-label {
            margin-top: 1px;
        }

        .select-container > label {
            margin-top: -6px;
        }

        .select-field.active label {
            margin-top: 0px;
        }

        .select-field.has-selected label {
            margin-top: 0px;
        }

        div#select-field-div.field-class-short {
            grid-area: select-field;
            margin-right: 24px;
        }

        div#field-config-render.field-class-short {
            width: 100%;
            margin-top: -32px;
            grid-area: field-value-config;
        }

        div#field-config-container.field-class-short {
            display: grid;
            grid-template-areas: 'select-field field-value-config';
            grid-template-columns: auto auto;
        }

        div#select-field-div.field-class-math-short {
            grid-area: select-field;
            width: 180px;
        }

        div#field-config-container.field-class-math-short {
            display: grid;
            grid-template-areas: 'select-field select-options-math select-field-math';
            grid-template-columns: auto auto auto;
        }

        div.math-option-values {
            display: grid;
            grid-area: select-options-math;
        }

        div.math-values {
            display: grid;
            grid-area: select-field-math;
        }

        .inf-field-wrapper span > label {
            margin-left: -0.25rem;
            background: linear-gradient(to top, transparent, transparent 43%, var(--input-background, white) 43%, var(--input-background, white) 51%, transparent 51%);
            font-size: var(--input-label-font-size, 0.875rem);
            font-weight: normal;
            padding: 0 0.25rem;
            top: 16px;
            transform: translateY(-50%);
            z-index: 1;
            width: auto;
            white-space: normal;
        }

        .date-checkbox > .content {
            padding-top: 0px;
        }

        div#field-config-render.companyInfo {
            margin-top: -24px;
        }

        div#field-config-render.contactNotes {
            width: 100%;
            height: 120px;
            margin-top: 6%;
            margin-bottom: 8%;
        }

        div#field-config-render.contactNotes textarea {
            width: 100%;
            border-radius: 8px;
        }

        div#field-config-render.custom_datetime {
            margin-top: -15px;
        }

        div#field-config-render.custom_datetime img {
            left: 234px;
        }

        div#field-config-render.custom_date {
            margin-top: -20px;
        }

        div#field-config-render.custom_date img {
            left: 234px;
        }

        div#field-config-render.custom_text {
            margin-top: -33px;
        }

        div#field-config-render.custom_textarea {
            width: 100%;
            height: 120px;
            margin-top: 6%;
            margin-bottom: 8%;
        }

        div#field-config-render.custom_website {
            margin-top: -18px;
        }

        div#field-config-render.custom-text-nbsp {
            margin-top: -18px;
        }

        div#field-config-render.custom_textarea textarea {
            width: 100%;
            border-radius: 8px;
        }

        div#field-config-render > .inf-field-wrapper > span.inf-label {
            width: auto;
        }

        div#lightbox {
            display: grid;
            grid-template-areas: 'containerclose headertext savebutton' 'lightboxcontent lightboxcontent lightboxcontent';
            grid-template-columns: 6% 80% 14%;
            background-color: #fff;
            width: 640px !important;
        }
        div#lightbox > div#lightbox-content {
            grid-area: lightboxcontent;
            border-top: 1px solid #DDDDDD;
        }
        form {
            padding: 15px;
        }
        div#lightbox > span.container-close {
            grid-area: containerclose;
            background-color: #fff;
            padding: 0;
            margin: 0;
            left: 20px;
            width: 10px;
            height: 10px;
            border-bottom: 1px solid #DDDDDD;
        }
        div#lightbox > div.hd {
            grid-area: headertext;
            background-color: #fff;
            border-bottom: none;
            height: 56px;
        }
        form > .savebutton {
            grid-area: savebutton;
            position: absolute;
            top: 12px;
            right: 16px;
            height: 32px;
            width: 55px;
            padding: 0;
        }
        div.dropdown-menu.open > div.menu {
            height: min-content;
        }
        .additional-info {
            display: inline-grid;
            grid-template-columns: 6% auto;
            justify-items: end;
            align-items: center;
            background-color: #f0f0f0 !important;
            box-shadow: none !important;
        }

        .additional-info > .ds-card-body {
            font-size: 12px;
        }
        .modal-footer {
            visibility: hidden;
            display: none;
        }

        .field-class-short .custom_radio table {
            width: auto;
        }

        .field-class-short .custom_radio {
            padding-top: 30px;
        }
    }
</style>
